// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media print{@page{size:A4;margin:0}.mid[data-v-5d0df2de],.print-margin[data-v-5d0df2de]{padding:0}}@media not print{.print-margin[data-v-5d0df2de]{background-color:#d3d3d3}.mid[data-v-5d0df2de]{padding:16px 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
